import { render, staticRenderFns } from "./dialogDig.vue?vue&type=template&id=0dd10806&scoped=true&"
import script from "./dialogDig.vue?vue&type=script&lang=js&"
export * from "./dialogDig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd10806",
  null
  
)

export default component.exports